<!-- eslint-disable tailwindcss/classnames-order -->
<template>
  <div class="min-h-navbar-height w-full bg-white">
    <Container
      id="jump-navigation"
      role="navigation"
      is-large
      class="
        relative w-full
        max-lg:pb-5
        print:px-0
        xl:pr-22
      "
    >
      <div
        class="
          relative flex h-auto flex-wrap items-end justify-between pb-5 pt-4
          lg:h-28 lg:flex-nowrap
        "
      >
        <!-- LOGO -->
        <div class="mr-auto w-2/3 self-start">
          <NuxtLink
            :to="logoUrl"
            target="_self"
            :aria-label="$t('aria_label.home')"
            @click="navigation.setOpenState(false); navigation.reset()"
          >
            <AppImage
              class="block h-20 w-auto object-contain"
              :src="globals?.logo.logo_image"
            />
          </NuxtLink>
        </div>
        <!-- META -->
        <div
          class="
            flex w-full flex-wrap
            lg:flex-nowrap lg:items-end lg:justify-end
          "
        >
          <LangSwitcher
            class="
              lg:ml-0 lg:pt-0
              max-lg:mb-4 max-lg:ml-auto max-lg:w-full
            "
          />
          <SearchInput
            class="
              mt-3 min-w-0
              lg:mt-0 lg:w-auto
              max-lg:ml-auto max-lg:mr-6 max-lg:max-w-120 max-lg:grow
              max-sm:mr-0 max-sm:w-full
            "
          />
          <NavActions
            class="
              lg:mx-2
              max-lg:mt-2
              max-sm:mb-2 max-sm:ml-auto max-sm:mt-8 max-sm:pl-6
            "
          />
        </div>

        <Hamburger
          :aria-label="$t('aria_label.main_navigation')"
          :class="{'xl:hidden': !navigation.open}"
        />
      </div>
    </Container>
    <NavCollapse />
  </div>
</template>

<script lang="ts" setup>
const {
  locales, localeProperties,
} = useI18n()

const globals = inject(GlobalsKey)
const navigation = useNavigationStore()

const logoUrl = computed(() => {
  // get the protocol of the current request
  const requestURL = useRequestURL()
  const { protocol } = requestURL

  // if logo_links_to is set to "home", return the current domain
  if (globals?.value.logo.logo_links_to.value === 'home') {
    const { domain } = localeProperties.value

    return `${protocol}//${domain}`
  }

  // get all aplus_ sites
  const mainSites = locales.value.filter(site => site.isMain)

  // get the current language tag
  const { languageTag } = localeProperties.value

  // get aplus url of the current language
  const domain = mainSites.find(site => site.languageTag === languageTag)?.domain

  return `${protocol}//${domain}`
})
</script>
